import { render } from "./EventFormDialog.vue?vue&type=template&id=a751cbc4&scoped=true"
import script from "./EventFormDialog.vue?vue&type=script&lang=js"
export * from "./EventFormDialog.vue?vue&type=script&lang=js"

import "./EventFormDialog.vue?vue&type=style&index=0&id=a751cbc4&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a751cbc4"]])

export default __exports__